import currencyFormatter from 'currency-formatter';

export type optionsStyleType = 'short' | 'effectiveShort' | 'long';
const getDollars = (cents: number): number => Math.ceil(cents / 100);

export const centsToDollarsDecimal = (cents) => {
  const numericCents = Number(cents);
  if (isNaN(numericCents)) {
    return 0;
  }
  const dollars = numericCents / 100;
  return dollars.toFixed(2);
};
/**
 * @example '$3,000.00' => '300000'
 */
export const dollarsToCents = (formattedDollar: string): string => {
  const dollars = currencyFormatter.unformat(formattedDollar, { code: 'USD' });
  const cents = Math.round(dollars * 100);
  return String(cents);
};

/**
 * @example 119999 => '$1200'
 */
const centsToDollarsShort = (cents: number): string =>
  getDollars(cents).toLocaleString('en-US', { style: 'currency', currency: 'USD' }).slice(0, -3);
const centsToDollarsLong = (cents: number): string =>
  (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });

/**
 * @example 1200.00 => '$1200'
 * @example 1200.50 => '$1200.50'
 */
const centsToDollarsEffectiveShort = (cents: number): string => {
  const dollars = getDollars(cents);
  if (dollars === cents / 100) {
    return centsToDollarsShort(cents);
  }
  return centsToDollarsLong(cents);
};

/**
 * @example 125000, {style: 'short'} => '$1250'
 * @example 125000, {style: 'effectiveShort'} => '$1250'
 * @example 125050, {style: 'effectiveShort'} => '$1251'
 * @example 125000 => '$1250.00'
 */
export const centsToDollars = (cents: number, options: { style?: optionsStyleType } = {}): string => {
  switch (options.style) {
    case 'short':
      return centsToDollarsShort(cents);
    case 'effectiveShort':
      return centsToDollarsEffectiveShort(cents);
    case 'long':
    default:
      return centsToDollarsLong(cents);
  }
};

export const removeNonDigit = (str) => {
  const newStr = str || '';
  return newStr.replace(/[A-Za-z!@#%^&*()=\-+$_/]/g, '');
};
